<div class="section-header">
    <div class="title">
        Handelt es sich bei dem Projekt um eine Ausschreibung?*
    </div>
    <div class="header-note">
        Bitte geben Sie an, ob es sich bei diesem Projekt um eine Ausschreibung handelt.
    </div>
</div>

<div class="note">
    Ausschreibungsdokumente werden benötigt, wenn die Laufzeit mehr als 24 Monate beträgt.
</div>

<div class="amount-input-container">
    <app-amount-input [(ngModel)]="tenderDocumentsValidationHelper"
                      name="documentsCount"
                      [forceFormValidationVisibility]="forceFormValidationVisibility"
                      #tenderDocumentsValidationHelperNgModel="ngModel"
                      [appValueIsValidFn]="projectHasTenderDocumentTestFn">
    </app-amount-input>
</div>


<div class="controls-container" bdFxLayoutAlign="start center" bdFxLayoutGap="15px" (focusout)="setAsTouched($event)">
    <bd-labeled-select-input bdFxFlex="0 0 150px"
                             [ngClass]="{'notify-change' : notifyChange( pUNFEnum.IS_TENDER)}"
                             [id]="'loader-select'"
                             [choices]="['Ja','Nein']" [values]="[true, false]"
                             [(ngModel)]="model.project.isTender"
                             (ngModelChange)="revalidateTenderDocumentsCount()"
                             [placeholder]="'Bitte auswählen'"
                             name="isTender"
                             required
                             [forceFormValidationVisibility]="forceFormValidationVisibility">
    </bd-labeled-select-input>

    <ng-container *ngIf="model.project.isTender">
        <div bdFxFlex="0 0 87px" class="button-container"
             [ngClass]="{'notify-change' :notifyChange( pUNFEnum.TENDER_DOCUMENTS) && model.project?.tenderDocuments?.length === 0,
             'error': forceFormValidationVisibility && model.project?.tenderDocuments?.length === 0}">
            <label class="btn btn-primary">
                     <span>
                        <bd-fa [name]="'upload'"></bd-fa>
                        Upload
                    </span>
                <input #fileInput
                       type="file"
                       accept=".pdf, .xls, .slsx, .doc, .docx"
                       (change)="processFile(fileInput)"
                       id="loader-button">
            </label>

        </div>
        <div class="info" bdFxFlex>Mehrere Dateien möglich, max. 10MB (PDF, Word, Excel)</div>
    </ng-container>

</div>

<div class="documents-container">
    <ng-container *ngIf="model.project.isTender">
        <div class="document" *ngFor="let document of model.project.tenderDocuments, let i = index"
             (click)="onDocumentClicked(i)"
             [ngClass]="{'notify-change' : notifyChange( pUNFEnum.TENDER_DOCUMENTS)}">
            <div class="label">{{document.fileName}}</div>
            <bd-fa-button [name]="'times'" (click)="onDocumentRemoveBtnClicked(i)"></bd-fa-button>
        </div>
    </ng-container>


    <bd-input-error-viewer [ngModelRef]="tenderDocumentsValidationHelperNgModel"
                           [customErrorsMsg]="{'appValueIsValidFn': 'Bitte laden Sie Ihre Ausschreibungsdokumente hoch.'}">
    </bd-input-error-viewer>


</div>



